var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29211",
    "data-name": "Group 29211",
    transform: "translate(360 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -11197)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_4_",
    "data-name": "svgexport-17 (4)",
    transform: "translate(-340 -11180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28916",
    "data-name": "Group 28916",
    transform: "translate(0 21.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49933",
    "data-name": "Path 49933",
    d: "M51.564,341.859l10.946,5.473a4.446,4.446,0,0,1,2.417,3.371l.273,1.986H32l.273-1.986a4.446,4.446,0,0,1,2.417-3.371l10.946-5.473Z",
    transform: "translate(-32 -341.859)",
    fill: "#ea9d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49934",
    "data-name": "Path 49934",
    d: "M34.689,347.333l.868-.434v5.791H32l.273-1.986A4.449,4.449,0,0,1,34.689,347.333ZM65.2,352.69H61.643V346.9l.868.434a4.449,4.449,0,0,1,2.416,3.371Zm-9.026-8.525L48.6,350.319l-7.574-6.154,2.551-1.275,2.059-1.029h5.929l2.4,1.2Z",
    transform: "translate(-32 -341.86)",
    fill: "#ea9d2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49935",
    "data-name": "Path 49935",
    d: "M208.3,312.823l-1.186-.593v-2.371h-5.929v2.371l-1.186.593,4.15,1.779Z",
    transform: "translate(-187.55 -290.452)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49936",
    "data-name": "Path 49936",
    d: "M221.929,309.86v.863l-.019.013a5.254,5.254,0,0,1-5.91-.013v-.863Z",
    transform: "translate(-202.364 -290.453)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49937",
    "data-name": "Path 49937",
    d: "M221.929,309.86v.863l-.019.013a5.254,5.254,0,0,1-5.91-.013v-.863Z",
    transform: "translate(-202.364 -290.453)",
    fill: "#e6af89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49938",
    "data-name": "Path 49938",
    d: "M35.557,409.86v5.791H32l.273-1.986a4.449,4.449,0,0,1,2.416-3.371ZM65.2,415.651H61.643V409.86l.868.434a4.449,4.449,0,0,1,2.416,3.371Z",
    transform: "translate(-32 -383.042)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49939",
    "data-name": "Path 49939",
    d: "M181.929,83.406a5.254,5.254,0,0,1-4.878-3.3A14.685,14.685,0,0,1,176,74.649V69.929a5.929,5.929,0,0,1,11.857,0v4.721a14.686,14.686,0,0,1-1.05,5.455,5.254,5.254,0,0,1-4.878,3.3Z",
    transform: "translate(-165.329 -62.813)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49940",
    "data-name": "Path 49940",
    d: "M274.371,169.186h-1.779a.593.593,0,1,1,0-1.186h1.779a.593.593,0,1,1,0,1.186Z",
    transform: "translate(-254.214 -159.106)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 0.741,
    cy: 0.741,
    rx: 0.741,
    ry: 0.741,
    transform: "translate(18.379 10.514)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49941",
    "data-name": "Path 49941",
    d: "M202.371,169.186h-1.779a.593.593,0,1,1,0-1.186h1.779a.593.593,0,1,1,0,1.186Z",
    transform: "translate(-187.55 -159.106)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 0.741,
    cy: 0.741,
    rx: 0.741,
    ry: 0.741,
    transform: "translate(13.339 10.514)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49942",
    "data-name": "Path 49942",
    d: "M241.779,220.354h-1.186a.593.593,0,0,1-.593-.593v-1.027a.593.593,0,0,1,1.186,0v.434h.593a.593.593,0,0,1,0,1.186Z",
    transform: "translate(-224.586 -205.531)",
    fill: "#e6af89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49943",
    "data-name": "Path 49943",
    d: "M146.594,173.859h-1.042A1.552,1.552,0,0,0,144,175.411v1.046a1.552,1.552,0,0,0,1.552,1.552h1.116Zm11.413,0h1.042a1.552,1.552,0,0,1,1.552,1.552v1.046a1.552,1.552,0,0,1-1.552,1.552h-1.116Z",
    transform: "translate(-135.7 -164.531)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49944",
    "data-name": "Path 49944",
    d: "M150.68,62.212h1.186a2.371,2.371,0,0,1,2.371,2.371h-5.929A2.371,2.371,0,0,1,150.68,62.212Zm6.521-4.15-.074-.3a5.529,5.529,0,0,0-2.3-3.259l-.015.006a16.649,16.649,0,0,1-6.126,1.191l-2.533.009a3.2,3.2,0,0,1-2.874-1.766l-.058-.115a3.148,3.148,0,0,1,.259-3.25l.043-.059a6.1,6.1,0,0,1,4.956-2.538h2.056a6.073,6.073,0,0,1,4.293,1.779h.24a2.478,2.478,0,0,1,2.223,1.37l.022.045a6.463,6.463,0,0,1,.492,4.465C157.506,56.842,157.2,58.062,157.2,58.062Z",
    transform: "translate(-134.672 -47.982)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49945",
    "data-name": "Path 49945",
    d: "M224,375.2l2.371,1.779,2.371-1.779-2.371-1.344Z",
    transform: "translate(-209.771 -349.709)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49946",
    "data-name": "Path 49946",
    d: "M168.948,357.025l-7.574,6.154-7.574-6.154,2.551-1.275,5.023,4.465,5.367-4.293Z",
    transform: "translate(-144.774 -332.942)",
    fill: "#c38325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49947",
    "data-name": "Path 49947",
    d: "M185.779,336l3.557,2.806-4.743,3.716-.593-4.9Zm7.114,0-3.557,2.806,4.743,3.716.593-4.9Z",
    transform: "translate(-172.736 -314.656)",
    fill: "#eaeae8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFather);
export default __webpack_public_path__ + "static/media/Father.3db4220a39dcb608fc4beb2e05f3a66c.svg";
export { ForwardRef as ReactComponent };